import React, { useRef, useContext, useCallback } from "react";
import {
  Box,
  Tabs,
  Tab,
  Typography,
  useMediaQuery,
  useTheme,
  Stack,
  Grid,
} from "@mui/material";
import LoanEmiCalculator from "../LoanEMICalculator/LoanEMICalculator";
import FeaturesUI from "../Features/FeaturesUI";
import LoanTypesSection from "../LoanTypes/LoanTypes";
import CityLoanGrid from "../CityGrid/CityLoanGrid";
import CareerLoanCarousel from "../LoanCarousel/LoanCarousel";
import SalaryLoanSection from "../LoanCarousel/LoanSectionCarousel";
import FAQSection from "../FaqSection/FaqSection";
import FeedbackCarousel from "../customerFeedback/customerFeedbackCarousel";
import BudgetCarouselSection from "../customerFeedback/BudgetCarouselSection";
import LandingPageContext from "../../context/landingContext";
import { DrawerComponent } from "@/components";
import { WEB_COLORS } from "@/lib/constants";

const navigationButtons = [
  { label: "Calculate EMI", key: "emi" },
  { label: "Features", key: "features" },
  { label: "Types of Personal Loan", key: "types" },
  { label: "Interest rates", key: "interest" },
  { label: "FAQ's", key: "faq" },
];
const LoanNavigationMenu = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { isDrawerOpen, setIsDrawerOpen } = useContext(LandingPageContext);

  const handleDrawer=  useCallback(setIsDrawerOpen,[setIsDrawerOpen]);

  const sectionRefs = {
    emi: useRef(null),
    features: useRef(null),
    types: useRef(null),
    interest: useRef(null),
    faq: useRef(null),
  };

  const scrollToSection = (key) => {
    sectionRefs[key]?.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <Grid>
      {!isMobile && (
        <Box
          sx={{
            bgcolor: "#fff",
            p: 2,
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Tabs value={false} textColor="inherit" indicatorColor="secondary">
            {navigationButtons?.map((item) => (
              <Tab
                key={item.key}
                label={item.label}
                onClick={() => scrollToSection(item.key)}
                sx={{
                  color: "#3F3F3FCC",
                  fontWeight: "bold",
                  textTransform: "none",
                }}
              />
            ))}
          </Tabs>
        </Box>
      )}

      {/* Sections */}
      <Box ref={sectionRefs.emi} sx={{ p: { xs: 2, md: 8 } }}>
        <LoanEmiCalculator />
      </Box>

      <Box ref={sectionRefs.features}>
        <FeaturesUI />
      </Box>

      <Box ref={sectionRefs.types}>
        <LoanTypesSection />
      </Box>

      <Box ref={sectionRefs.interest}>
        <CityLoanGrid />
        <CareerLoanCarousel />
        <SalaryLoanSection />
        <FeedbackCarousel />
        <BudgetCarouselSection />
      </Box>

      <Box ref={sectionRefs.faq}>
        <FAQSection />
      </Box>
      {isMobile && isDrawerOpen && (
        <DrawerComponent
          anchor={"right"}
          open={isDrawerOpen}
          handleDrawer={handleDrawer}
          p={6}
        >
          {navigationButtons?.map((item) => (
            <Grid key={item?.key} display={'flex'} flexDirection={'column'} alignItems={'center'}>
              <Typography
                sx={{
                  color: WEB_COLORS.darkTeal,
                  fontWeight: "bold",
                  textTransform: "none",
                  p:1,
                  cursor:'pointer'
                }}
                onClick={() => {
                  scrollToSection(item.key)
                  setIsDrawerOpen(!isDrawerOpen)
                }}
              >
                {item.label}
              </Typography>
            </Grid>
          ))}
        </DrawerComponent>
      )}
    </Grid>
  );
};

export default LoanNavigationMenu;
